import './Hero.scss';
import HeroImg from '../../assets/img/hero-img.png';

const Hero = () => {
    return (
        <div className="Hero">
            <div className="container">
                <div className="row justify-content-between px-5">
                    <div className="col-md-6">
                        <h1 className="hero-title">Be the best player as you can go.</h1>
                        <p className="hero-subtitle lead">Find out more than millions of poppular games that you can play with your friends!</p>
                        <a href="#popular" className="btn btn-outline-danger btn-lg px-3">See more</a>
                    </div>
                    <div className="col-md-6">
                        <img className="img-fluid" loading="lazy" src={HeroImg} alt="Welcome to Land of Game"/>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Hero;
